import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, CircularProgress } from "@mui/material";
import { FileDownload, SmsFailed } from "@mui/icons-material";
import axios from "axios";
import { health_api } from "../../../Config.js";
import Box from "@mui/material/Box";
import { useSearchParams } from "react-router-dom";
import { updateBajajPolicyNumber } from "../../../Redux/Health/action.js";
import { decryptData } from "../../../Framework/Utils/decrypt.js"
import {encryptData} from "../../../Framework/Utils/encrypt.js"

export const HealthPaymentSuccess = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const [policyNum, setPolicyNumber] = useState("");
  const [parms] = useSearchParams();
  const dispatch = useDispatch();
  let provider = useSelector((state) => state?.healthReducer?.selectedProvider);
  console.log(paymentDetails, "paymentDetailspaymentDetails");
  const hdfcPolicyData = useSelector(
    (state) => state?.healthReducer?.hdfcPolicydata
  );
  const txnID = useSelector((e) => e?.healthReducer?.generatedHDFCTxnId);
  const careProposalNum = useSelector(
    (state) => state?.healthReducer.proposalNum
  );
  let bajajPolicyNumber = parms.get("referenceno");
  let bajajamount = parms.get("amt");
  let bajajstatus = parms.get("status");
  const output = parms.get("Output");

  // Split the output if it's available
  const outputValues = output ? output.split("|") : [] ;
  console.log(output,outputValues,"vgvhgvgvb")
  let ReliancePolicyNumber=outputValues[1];
  let RelianceProposalNumber=outputValues[5];

  const proposalRequest = useSelector(
    (state) => state?.healthReducer?.proposalRequestData
  );

  const quotationData = useSelector(
    (state) => state?.healthReducer?.quotationData
  );
  console.log(quotationData,"hghjdgsjh")


  useEffect(() => {
    if (provider === "bajaj") {
      dispatch(updateBajajPolicyNumber(bajajPolicyNumber));
    }
  }, [bajajPolicyNumber, provider, dispatch]);

  console.log(bajajPolicyNumber, "console in line number 32");

  useEffect(() => {
    let reqBody;
    if (provider === "CARE") {
      reqBody = {
        proposalNum: careProposalNum,
        provider: "CARE",
        proposalRequest: proposalRequest,
      };
    } else if (provider === "HDFC") {
      // alert(JSON.stringify(hdfcPolicyData));
      // reqBody = hdfcPolicyData;
      reqBody = {
        hdfcPolicyData,
        provider: "HDFC",
        proposalRequest: proposalRequest,
      };
    } else if (provider === "bajaj") {
      setPaymentDetails({
        policyNum: bajajPolicyNumber,
        policyStatus: "Active",
      });

      setIsLoading(false);
      return;
    }else if(provider==="RELIANCE"){
      setPaymentDetails({
        policyNum: ReliancePolicyNumber,
        policyStatus:"Active",
      });
      setIsLoading(false);
      console.log(paymentDetails,"hghsdgghjsdghjh")
      return;
      
    }
    const fetchData = async () => {
      try {
        if (provider !== "bajaj" || provider !=="RELIANCE" || hdfcPolicyData || careProposalNum) {
              const encryptedData=encryptData(reqBody)
          const response = await axios.post(
            `${health_api}/insurance/v1/health/policy/submitpayment`,
            // "http://localhost:8083/insurance/v1/health/submitpayment",
           { payload:encryptedData}
          );
    const decryptRespose=decryptData(response?.data)
    
          if (provider === "CARE") {
           
            setPaymentDetails(decryptRespose?.intGetPolicyStatusIO);
            setPolicyNumber(decryptRespose?.intGetPolicyStatusIO?.policyNum);
          } else {
            setPaymentDetails(decryptRespose?.Policy_Details);
            setPolicyNumber(decryptRespose?.Policy_Details?.PolicyNumber);
          }
        } else {
          console.error("hdfcPolicyData is undefined");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [hdfcPolicyData, provider, careProposalNum]);

  const handleDownload = async () => {
    let req;

    if (provider === "HDFC") {
      req = {
        provider: "HDFC",
        txnID: txnID,
        policyNum: policyNum,
      };
    } else if (provider === "CARE") {
      req = {
        provider: "CARE",
        policynum: policyNum,
      };
    } else if (provider === "bajaj") {
      req = {
        provider: "BAJAJ",
        policynum: bajajPolicyNumber,
      };

    }else if (provider === "RELIANCE") {
      req = {
        provider: "RELIANCE",
        policynum: ReliancePolicyNumber,
      };
      
    }
    console.log(req, "request in line 111");

    try {
      const encryptReq=encryptData(req)
      setDownloading(true);
      const res = await axios.post(
        `${health_api}/insurance/v1/health/policy/pdfgenerate`,
        // "http://localhost:8083/insurance/v1/health/policy/pdfgenerate",
        {payload:encryptReq}
      );
      console.log(res, provider, "responseee in line 121");
      let decryptRespose=decryptData(res.data)
      let base64String;
      if (provider === "HDFC") {
        console.log(decryptRespose, "decryptRespose");
        base64String = decryptRespose?.Resp_Policy_Document?.PDF_BYTES;
      } else if (provider === "CARE") {
        console.log(res, "response");
        base64String = decryptRespose?.intFaveoGetPolicyPDFIO?.dataPDF;
      } else if (provider === "bajaj") {
        console.log(res, "res");
        const dataobj = decryptRespose?.body?.fileByteObj;
        // const parsedObj=JSON.parse(dataobj)
        console.log(dataobj, "datatatatta in 133");
        console.log(
          res?.data?.body?.fileByteObj,
          "res?.data?.body?.fileByteObj"
        );
        // base64String =parsedObj.fileByteObj
      }else if(provider ==="RELIANCE"){
        console.log(res,"responseeeee")
        const downloadLink=decryptRespose?.DownloadLink;
        console.log(downloadLink,"ajskd")
        window.location.href=downloadLink
      }

      console.log(base64String, "base64Stringbase64String");
      let fileName = "lmv_customerId.pdf";
      const data = base64String.replace(/^data:application\/pdf;base64,/, "");
      const byteCharacters = atob(data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      console.log(url, "blob url");
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = fileName;
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      setDownloading(false);
    } catch (error) {
      setDownloading(false);
      console.log(error, "couldn't download pdf");
    }
  };



  const showKycStatus = provider === "HDFC";

  if (isLoading || !paymentDetails) {
    return (
      <Box
        sx={{
          height: "700px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className="payment-container">
      <div className="payment-success-table-container">
        <div className="payment-success-table">
          <div className="payment-success-table-header">
            Amount
            <span style={{ fontWeight: "500", fontSize: "18px" }}>
              ₹{" "}
              {provider === "CARE" || provider === "bajaj"
                ? provider === "CARE"
                  ? paymentDetails?.policyPremium
                  : bajajamount
                :provider==="RELIANCE"? quotationData?.premiumWithGST: paymentDetails?.TotalPremium}
            </span>
          </div>
          <div className="payment-success-table-divider">
            <ul className="payment-success-list">
              <li>
                <span>Proposal Number</span>
                <span className="application-id">
                  {provider === "CARE"||provider==="RELIANCE"
                    ?provider==="CARE"? paymentDetails?.proposalNum:RelianceProposalNumber
                    : paymentDetails?.ProposalNumber}
                </span>
              </li>
              <li>
                <span>Policy Number</span>
                <span>

                  {provider === "CARE" || provider === "bajaj"
                    ? provider === "CARE"
                      ? paymentDetails?.policyNum
                      : bajajPolicyNumber
                    :provider==="RELIANCE"?ReliancePolicyNumber: paymentDetails?.PolicyNumber}
                </span>
              </li>
              <li>
                <span>Policy Status</span>
                <span>
                  {/* {paymentDetails?.policyStatus} */}

                  {provider === "bajaj"
                    ? bajajstatus
                    : paymentDetails?.policyStatus}
                </span>
              </li>
              <li>
                <span>Merchant Name</span>
                <span>LMVIB</span>
              </li>
              <li>
                <span>Payment Method</span>
                <span>Online</span>
              </li>
              <li>
                <span>Policy Start Date</span>
                {provider === "CARE"
                  ? paymentDetails?.policyCommencementDt
                  : paymentDetails?.PolicyStartDate}
              </li>
              <li>
                <span>Policy Provider</span>
                <span>{provider}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="kyc-failed-container">
          <div className="kyc-failed-content">
            <p className="kyc-failed-content-title">Download Policy</p>
            <p>
              Download your <span style={{ color: "#23A8FA" }}>Policy</span>{" "}
              here.
            </p>
            <Button className="kyc-failed-btn" onClick={handleDownload}>
              <span style={{ fontWeight: "700", color: "white" }}>
                {downloading ? "Downloading..." : "Download"}
              </span>
            </Button>
           
          </div>
          
         
          <div style={{ marginLeft: "22px" }}>
            {showKycStatus ? <FileDownload /> : <SmsFailed />}
          </div>
        </div>
      </div>
    </div>
  );
};
